module.exports = __webpack_public_path__ + "media/images/icon/icons8-Thumbnails-27f353c089a91155b6c7c6ce04d4c090.png";